import { Base } from "./base";
import { dateFormat } from "../utils/helper";
import { getAccessToken } from "../utils/browserStorage";
export class Alert extends Base {
  #getURLWithQueryString(endpoint, { machine, startTs, stopTs }, timestamp) {
    const url = new URL(this._getFullURL(endpoint));
    const params = { machine };
    if (startTs) {
      params["start_ts"] = timestamp
        ? startTs
        : `${dateFormat(startTs * 1000)} 00:00`;
    }
    if (stopTs) {
      params["stop_ts"] = timestamp
        ? stopTs
        : `${dateFormat(stopTs * 1000)} 23:59:59`;
    }
    url.search = new URLSearchParams(params).toString();
    return url;
  }
  /**
   * @description List Alert API function
   * @returns {Promise<Response>}
   */
  list() {
    const url = this._getFullURL("/alert/");
    return fetch(url, this._generateRequestBody({}));
  }
  /**
   * @description List Machinary Class API function
   * @returns {Promise<Response>}
   */
  listMachinaryClass() {
    const url = this._getFullURL("/classes/");
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  listTransactionByMachineTime(filterParams) {
    const url = this.#getURLWithQueryString(
      "/alert/machine",
      filterParams,
      false
    );
    return this._secureFetch(url);
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  listTransactionByTimeOnly(filterParams) {
    const url = this.#getURLWithQueryString(
      "/alert/time_only",
      filterParams,
      false
    );
    return this._secureFetch(url);
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  listSeverityGroupByMachine(filterParams) {
    const url = this.#getURLWithQueryString(
      "/alert/byseverity_machine",
      filterParams,
      false
    );
    return this._secureFetch(url);
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  listAllSeverity(filterParams) {
    const url = this.#getURLWithQueryString(
      "/alert/all_severity",
      filterParams,
      false
    );
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description List Action for Alert
   * @returns {Promise<Response>}
   */
  listAction() {
    const url = this._getFullURL("/action/");
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  genereateURLforAudioPlay(audio_url) {
    const url = this._getFullURL(`/alert/audio?url=${audio_url}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  genereateURLforAudioPlayPost = (audio_url) => {
    const url = this._getFullURL("/alert/audio");
    const payload = { url: audio_url };
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  };
  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  genereateURLforAudioPlayDecamouflage = (audio_url) => {
    const url = this._getFullURL("/alert/audio_decamouflage");
    const payload = { url: audio_url };
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  };

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  genereateAudioFromNAS(zip_name, wav_name) {
    const url = this._getFullURL(
      `/alert/get_audio_sftp?zip_name=${zip_name}&wav_name=${wav_name}`
    );
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  decryptAudio(file_url) {
    const url = this._getFullURL("/alert/decode_audio");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: { file_url },
        method: "POST",
      })
    );
  }

  /**
   * @description List Alert Transaction per machine and timerange
   * @returns {Promise<Response>}
   */
  listAudioByMachineTime(filterParams) {
    const url = this.#getURLWithQueryString(
      "/alert/machine",
      filterParams,
      true
    );
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Create Alert API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  create(payload) {
    const url = this._getFullURL("/alert/");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }

  /**
   * @description Create New Reason API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  addNewReason(payload) {
    const url = this._getFullURL("/reason/");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }

  /**
   * @description Create New Action API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  addNewAction(payload) {
    const url = this._getFullURL("/action/");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }

  /**
   * @description Create Alert API function
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  submitAudio(fileInput, action) {
    const url = this._getFullURL("/alert/encode_audio");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("file", fileInput, "audio.wav");
    formdata.append("action", action);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  /**
   * @description Get Alert API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  get(id) {
    const url = this._getFullURL(`/alert/${id}`);
    return fetch(url, this._generateRequestBody({}));
  }

  /**
   * @description Get Alert API function
   * @returns {Promise<Response>}
   */
  getFirstRecord() {}

  /**
   * @description Update Alert API function
   * @param {string} id
   * @param {object} payload
   * @returns {Promise<Response>}
   */
  update = (payload) => {
    const url = this._getFullURL(`/alert/update_alert`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  };

  /**
   * @description Delete Alert API function
   * @param {string} id
   * @returns {Promise<Response>}
   */
  delete = (id) => {
    const url = this._getFullURL(`/alert/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
